import { Card, Button, Tooltip, notification,Form, } from 'antd'
import _ from 'lodash'
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import { getAllAbstracts } from '../actions/index'
import AbstractActivityList from '../AbstractActivityList'
import AbstractFilters from './AbstractFilters'
import RevisedAbstractDrawer from '../abstractPages/RevisedAbstractDrawer'

@Form.create()
class RejectedAbstract extends Component {
  state = {
    filters: {},
    visibleRevisedAbstract: false,
    abstract: {},
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Rejection'
      }
      let data = await dispatch(getAllAbstracts({ ...obj }))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => { this.table.current.reload() }

  render() {
    const { loading } = this.props
    const columns = [
      {
        key: 'abstractId',
        title: 'Abstract ID',
        width: '100px',
        render: (val, record) => (
          <a href={`/abstractView/${record._id}`}>{record.onlineAbstractId}</a>
        )
      },
      { title: 'Submitted Date', dataIndex: 'createdAt', width: 120, render: item => DisplayDate(item) },
      { title: 'Title', dataIndex: 'titleOfAbstract', render: item => item ? ReactHtmlParser(item) : null },
      { title: 'Rejection Date', dataIndex: 'rejectionDate', width: 120, render: item => DisplayDate(item) },
      {
        title: 'Comments Received',
        key: 'receiveDate',
        width: 120,
        render: (text, record) => {
          // Check if selectedReviewer exists and has items
          if (record.selectedReviewer && record.selectedReviewer.length > 0) {
            // Access the receiveDate from the specific reviewer object
            const date = record.selectedReviewer[0].receiveDate;
            return date ? DisplayDate(date) : null;
          }
          return null;
        }
      },
      {
        title: 'Comments Send',
        key: 'sendToAuthorDate',
        width: 120,
        dataIndex: 'sendToAuthorDate',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Action',
        render: (item, record) => (
          <>
            <Button className={'roundSmallBtn'} onClick={() => this.setState({ visibleRevisedAbstract: true, abstract: record })}>
              Revised Abstract
            </Button>
            <Button className={'roundSmallBtn'} onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
              Activities
            </Button>
          </>
        )
      }
    ]

    return (
      <PageHeaderWrapper title={`Rejected Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters callback={data => { this.setState({ filters: data }, this.reload) }} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>
        {this.state.visibleActivityList ? (
          <AbstractActivityList
            abstractId={this.state.abstract._id}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        ) : null}
        {this.state.visibleRevisedAbstract && (
          <RevisedAbstractDrawer
            visible={this.state.visibleRevisedAbstract}
            abstract={this.state.abstract}
            onClose={() => this.setState({ visibleRevisedAbstract: false })}
            callback={this.reload}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

export default connect(null)(RejectedAbstract)
